import { useContext } from "react";
import { CommentContext } from "./CommentProvider";

export const useCommentContext = () => useContext(CommentContext);

export default useCommentContext;
